import { observable, action, autorun, computed, toJS } from 'mobx'
import http from 'src/helper/http'
import cdn from 'src/helper/cdn'

export default class {
  @observable data = {
    uid: 0,
    userInfo: {
      avatarurl: ""
    },
    remaintime: 0,
    now: 0,
    rankUser: { country: [], world: [], countryMyrank:{}, worldMyrank:{}},
    rankGroup: { country: [], world: [] ,countryMyrank:{}, worldMyrank:{}},
    countryId: 121,
  }


  @action async GetUserInfoWeb() {
    this.data.notNetwork = false
    let d = await http.post('/web/MyAccountInfo', {})
    if (d && d.code == 0 && d.res && d.res.uid > 0) {
      this.data.userInfo = d.res
    }else{
      this.data.notNetwork = true
    }
  }

  @action async GetServerTime(map) {
    let d = await http.post('/web/nationalday/count/down', map)
    if (d.code == 0) {
      // this.data.now = d.res.now
      let ts = d.res
      if (ts > 0) {
        this.data.remaintime = ts
      }
    }
  }

  @action async setUid(uid) {
    this.data.uid = uid
  }

  @action async Rank(type) {
    let d = await http.post('/web/nationalday/rank/user', { "type": type || 2 })
    for (let i = 0; i < d.res.list.length; i++) {
      if (d.res.list[i].val > 1000000) {
        d.res.list[i].val = parseInt(d.res.list[i].val / 100000) / 10 + 'M'
      } else if (d.res.list[i].val > 1000) {
        d.res.list[i].val = parseInt(d.res.list[i].val / 100) / 10 + 'K'
      }
    }
    if (d.res.myrank.val > 1000000) {
      d.res.myrank.val = parseInt(d.res.myrank.val / 100000) / 10 + 'M'
    }else if (d.res.myrank.val > 1000){
      d.res.myrank.val = parseInt(d.res.myrank.val / 100) / 10 + 'K'
    }

    if (type == 1){
      this.data.rankUser.country = d.res.list
      this.data.rankUser.countryMyrank = d.res.myrank
    }else {
      this.data.rankUser.world = d.res.list
      this.data.rankUser.worldMyrank = d.res.myrank
    }
   
    // this.data.rankUser = d.res
    return
  }

  @action async GroupRank(type) {
    let d = await http.post('/web/nationalday/rank/group', { "type": type || 2 })
    for (let i = 0; i < d.res.list.length; i++) {
      if (d.res.list[i].val > 1000000) {
        d.res.list[i].val = parseInt(d.res.list[i].val / 100000) / 10 + 'M'
      } else if (d.res.list[i].val > 1000) {
        d.res.list[i].val = parseInt(d.res.list[i].val / 100) / 10 + 'K'
      }
    }

    if (d.res.myrank.val > 1000000) {
      d.res.myrank.val = parseInt(d.res.myrank.val / 100000) / 10 + 'M'
    }else if (d.res.myrank.val > 1000){
      d.res.myrank.val = parseInt(d.res.myrank.val / 100) / 10 + 'K'
    }

    if (type == 1){
      this.data.rankUser.country = d.res.list
      this.data.rankUser.countryMyrank = d.res.myrank
    }else {
      this.data.rankGroup.world = d.res.list
      this.data.rankGroup.worldMyrank = d.res.myrank
    }
    return
  }
}



// WEBPACK FOOTER //
// src/store/activity/kuwait.js